export const NEXCAILBER_QUERY_USERS = [
	// { label: "Choose from Below", value: "choose" },
	{ label: "BROKER/ AGENT", value: "broker_agent" },
	{ label: "EMPLOYER", value: "employer" },
	{ label: "MEMEBR", value: "member" },
	{ label: "PROVIDER", value: "provider" },
	{ label: "OTHERS", value: "others" }
];
